import React, { useRef, useEffect, useState } from 'react'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import GameInvitations from './game-invitations'
import { ajaxGet, ajaxPost } from '../../ajax'

export default function GameAnnouncements({game, onClose, onShowPlayer, onAlert}) {
  const [players, setPlayers] = useState([])
  const [title, setTitle] = useState('')
  const [loading, setLoading] = useState(false)
  const [showInvitation, setShowInvitation] = useState(false)
  const [distance, setDistance] = useState(7)
  const [results, setResults] = useState(50)
  const copyPhonesRef = useRef(null)
  const distanceOptions = [3,5,7,9]
  const resultsOptions = [10,25,50,100]

  useEffect(() => {
    getAnnouncements()
  }, [distance, results])

  const getAnnouncements = async () => {
    setLoading(true)
    const options = { distance: distance, results: results }
    const response = await ajaxGet(`/admins/games/${game.id}/announcements.json?` + new URLSearchParams(options))
    const json = await response.json()
    setPlayers(json.players)
    setTitle(json.title)
    setLoading(false)
  }

  const onInvite = (data) => {
    setShowInvitation(false)
    if (!players.length) return onAlert({text: 'No players to invite', type: 'error'})

    sendInvitation(data)
  }

  const sendInvitation = async (data) => {
    setLoading(true)
    const params = {invitation: {title: data.title, message: data.message, players_ids: players.map(el => el.id)}}
    const response = await ajaxPost(`/admins/games/${game.id}/game_invitations.json`, params)
    const json = await response.json()
    onAlert(json)
    setLoading(false)
  }

  const playerPhones = (separator) => {
    let phones = []
    players.map(pl => phones.push(formattedPhone(pl)))
    return phones.join(separator)
  }

  const copyPhones = (separator) => {
    navigator.clipboard.writeText(playerPhones(separator))
    copyPhonesRef.current.blur()
  }

  const formattedPhone = player => {
    const intlPhone = player.country_code && player.country_code.toLowerCase() != 'us'
    const result = intlPhone ? formatPhoneNumberIntl(player.phone) : formatPhoneNumber(player.phone)

    return intlPhone ? result.replaceAll(' ', '-') : result
  }

  const playerTitle = (player) => {
    return player.name + ' - ' + formattedPhone(player)
  }
  
  const playerLink = (i) => {
    const player = players[i]
    return <h5>
      <a className='clickable player-link' onClick={() => onShowPlayer(player.id)}>
        {`${i + 1}. ${playerTitle(player)}`}
      </a>
    </h5>
  }

  const showPlayers = () => {
    const middle = Math.round(players.length / 2)
    var result = []
    for (var i = 0; i < middle; i++) {
      result.push(<tr key={i}>
        <td>{playerLink(i)}</td>
        <td>{players[i + middle] && playerLink(i + middle)}</td>
      </tr>)
    }
    return result
  }

  return <div className={'game-announcements' + (loading ? ' isLoading' : '')}>
    { showInvitation && 
      <GameInvitations location={game.location_name} onCreate={onInvite} onClose={() => setShowInvitation(false)} />
    }
    <div className='game-announcements__header'>
      <div className='back-button'><a className='btn btn-back' onClick={onClose}></a></div>
      <div className='content text-center'>
        <div className='title'>Game Announcements</div>
        <div className='desc'>{title}</div>
      </div>
    </div>

    { loading && <div className='animated-spinner'></div> }
    <table className='table table-striped game-announcements__table'>
      <thead>
        <tr>
          <th className='player-name'>Player Name</th>
          <th className='announcements-actions'>
            <label>
              Distance
              <select className='form-control' value={distance} onChange={e => setDistance(e.target.value)}>
                { distanceOptions.map((o, i) => { return <option key={i} value={o}>{o}</option> }) }
              </select>
            </label>
            <label>
              Results
              <select className='form-control' value={results} onChange={e => setResults(e.target.value)}>
                { resultsOptions.map((o, i) => { return <option key={i} value={o}>{o}</option> }) }
              </select>
            </label>

            <button className='btn btn-default game-invite' onClick={() => setShowInvitation(true)}>
              <span className='fa fa-commenting-o' title='Game Invitation'></span>
            </button>
            <button className='btn btn-default copy-btn copy-phones'
                    ref={copyPhonesRef}
                    onClick={() => copyPhones(' ')}>
              <span className='fa fa-clipboard' title='Copy Phone Numbers without commas'></span>
            </button>
            <button className='btn btn-default copy-btn'
                    ref={copyPhonesRef}
                    onClick={() => copyPhones(', ')}>
              <img title='Copy Phone Numbers with commas' src='/images/players/comma.svg' />
            </button>
          </th>
        </tr>
      </thead>
      <tbody className='player-wrapper'>{!!players.length && showPlayers()}</tbody>
    </table>
  </div>
}
